"use client";
import { useState } from "react";
import "./style.css";

export default function NewsLetter() {
  const [subscribed, setSubscribed] = useState(false);
  const [newsletterData, setNewsletterData] = useState({
    name: "",
    email: "",
  });

  const [errors, setErrors] = useState<{ name?: string; email?: string }>({});

  const handleNewsletterChange = (field: string, value: string) => {
    setNewsletterData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  // const submitForm = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   const newErrors: { name?: string; email?: string } = {};
  //   const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  //   if (!newsletterData.name.trim()) {
  //     newErrors.name = "Enter Name!";
  //   }
  //   if (newsletterData.name.length < 3) {
  //     newErrors.name = "Name must be 3 letters!";
  //   }

  //   if (!newsletterData.email.trim()) {
  //     newErrors.email = "Enter Email!";
  //   } else if (!emailRegex.test(newsletterData.email)) {
  //     newErrors.email = "Enter valid email!";
  //   }

  //   if (Object.keys(newErrors).length) {
  //     setErrors(newErrors);
  //     return;
  //   }

  //   try {
  //     const res = await fetch("/api/subscribe", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(newsletterData),
  //     });

  //     const data = await res.json();
  //     console.log("Subscribe Response:", data);

  //     if (res.ok) {
  //       alert("Subscribed Successfully!"); // simple browser alert
  //       setNewsletterData({ name: "", email: "" });
  //       setErrors({});
  //     } else {
  //       alert("Subscription failed!");
  //     }
  //   } catch (err) {
  //     console.error("Subscribe error:", err);
  //     alert("Server error!");
  //   }
  // };

  const submitForm = async (e: React.FormEvent) => {
    e.preventDefault();

    const newErrors: { name?: string; email?: string } = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!newsletterData.name.trim() || newsletterData.name.length < 3) {
      newErrors.name = "Name must be 3 letters!";
    }

    if (!newsletterData.email.trim()) {
      newErrors.email = "Enter Email!";
    } else if (!emailRegex.test(newsletterData.email)) {
      newErrors.email = "Enter valid email!";
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newsletterData),
      });

      const data = await res.json();
      console.log("Subscribe Response:", data);

      if (res.ok) {
        setSubscribed(true); // ✅ show success message
        setNewsletterData({ name: "", email: "" });
        setErrors({});
      } else {
        alert("Subscription failed!");
      }
    } catch (err) {
      console.error("Subscribe error:", err);
      alert("Server error!");
    }
  };


  return (
    <div
      className="newsletter-wrapper"
      style={{
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2)), url(/Newsletter-coinccino-signup.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="newsletter-container container">
        <h2 className="newsletter-title">SUBSCRIBE TO THE NEWSLETTER</h2>

        <p className="newsletter-subtitle">
          Coinccinos brings you the weekly summary of major Web3-related news.
        </p>

        {subscribed ? (
          <div className="newsletter-success text-center">
            <p style={{ fontSize: "18px", color: "#fff" }}>
              To complete your subscription, click the <br />
              confirmation link in your inbox. If it <br />
              doesn’t arrive within 3 minutes, check <br />
              your spam folder.
            </p>
          </div>
        ) : (

          <form className="newsletter-form" noValidate onSubmit={submitForm}>
            <div className="newsletter-input-wrapper">
              <input
                className="newsletter-input"
                type="text"
                placeholder="Full Name"
                value={newsletterData.name}
                onChange={(e) => handleNewsletterChange("name", e.target.value)}
              />

              <input
                className="newsletter-input"
                type="email"
                placeholder="Your Email Address"
                value={newsletterData.email}
                onChange={(e) => handleNewsletterChange("email", e.target.value)}
              />
            </div>

            <button className="newsletter-submit-button" type="submit">
              SUBSCRIBE
            </button>
          </form>
        )}
        {(errors.name || errors.email) && (
          <small className="text-2xl text-red-800 error">
            {errors.name || errors.email}
          </small>
        )}
      </div>
    </div>
  );
}
